import _toConsumableArray from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return e; }; var t, e = {}, r = Object.prototype, n = r.hasOwnProperty, o = Object.defineProperty || function (t, e, r) { t[e] = r.value; }, i = "function" == typeof Symbol ? Symbol : {}, a = i.iterator || "@@iterator", c = i.asyncIterator || "@@asyncIterator", u = i.toStringTag || "@@toStringTag"; function define(t, e, r) { return Object.defineProperty(t, e, { value: r, enumerable: !0, configurable: !0, writable: !0 }), t[e]; } try { define({}, ""); } catch (t) { define = function define(t, e, r) { return t[e] = r; }; } function wrap(t, e, r, n) { var i = e && e.prototype instanceof Generator ? e : Generator, a = Object.create(i.prototype), c = new Context(n || []); return o(a, "_invoke", { value: makeInvokeMethod(t, r, c) }), a; } function tryCatch(t, e, r) { try { return { type: "normal", arg: t.call(e, r) }; } catch (t) { return { type: "throw", arg: t }; } } e.wrap = wrap; var h = "suspendedStart", l = "suspendedYield", f = "executing", s = "completed", y = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var p = {}; define(p, a, function () { return this; }); var d = Object.getPrototypeOf, v = d && d(d(values([]))); v && v !== r && n.call(v, a) && (p = v); var g = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(p); function defineIteratorMethods(t) { ["next", "throw", "return"].forEach(function (e) { define(t, e, function (t) { return this._invoke(e, t); }); }); } function AsyncIterator(t, e) { function invoke(r, o, i, a) { var c = tryCatch(t[r], t, o); if ("throw" !== c.type) { var u = c.arg, h = u.value; return h && "object" == typeof h && n.call(h, "__await") ? e.resolve(h.__await).then(function (t) { invoke("next", t, i, a); }, function (t) { invoke("throw", t, i, a); }) : e.resolve(h).then(function (t) { u.value = t, i(u); }, function (t) { return invoke("throw", t, i, a); }); } a(c.arg); } var r; o(this, "_invoke", { value: function value(t, n) { function callInvokeWithMethodAndArg() { return new e(function (e, r) { invoke(t, n, e, r); }); } return r = r ? r.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(e, r, n) { var o = h; return function (i, a) { if (o === f) throw Error("Generator is already running"); if (o === s) { if ("throw" === i) throw a; return { value: t, done: !0 }; } for (n.method = i, n.arg = a;;) { var c = n.delegate; if (c) { var u = maybeInvokeDelegate(c, n); if (u) { if (u === y) continue; return u; } } if ("next" === n.method) n.sent = n._sent = n.arg;else if ("throw" === n.method) { if (o === h) throw o = s, n.arg; n.dispatchException(n.arg); } else "return" === n.method && n.abrupt("return", n.arg); o = f; var p = tryCatch(e, r, n); if ("normal" === p.type) { if (o = n.done ? s : l, p.arg === y) continue; return { value: p.arg, done: n.done }; } "throw" === p.type && (o = s, n.method = "throw", n.arg = p.arg); } }; } function maybeInvokeDelegate(e, r) { var n = r.method, o = e.iterator[n]; if (o === t) return r.delegate = null, "throw" === n && e.iterator.return && (r.method = "return", r.arg = t, maybeInvokeDelegate(e, r), "throw" === r.method) || "return" !== n && (r.method = "throw", r.arg = new TypeError("The iterator does not provide a '" + n + "' method")), y; var i = tryCatch(o, e.iterator, r.arg); if ("throw" === i.type) return r.method = "throw", r.arg = i.arg, r.delegate = null, y; var a = i.arg; return a ? a.done ? (r[e.resultName] = a.value, r.next = e.nextLoc, "return" !== r.method && (r.method = "next", r.arg = t), r.delegate = null, y) : a : (r.method = "throw", r.arg = new TypeError("iterator result is not an object"), r.delegate = null, y); } function pushTryEntry(t) { var e = { tryLoc: t[0] }; 1 in t && (e.catchLoc = t[1]), 2 in t && (e.finallyLoc = t[2], e.afterLoc = t[3]), this.tryEntries.push(e); } function resetTryEntry(t) { var e = t.completion || {}; e.type = "normal", delete e.arg, t.completion = e; } function Context(t) { this.tryEntries = [{ tryLoc: "root" }], t.forEach(pushTryEntry, this), this.reset(!0); } function values(e) { if (e || "" === e) { var r = e[a]; if (r) return r.call(e); if ("function" == typeof e.next) return e; if (!isNaN(e.length)) { var o = -1, i = function next() { for (; ++o < e.length;) if (n.call(e, o)) return next.value = e[o], next.done = !1, next; return next.value = t, next.done = !0, next; }; return i.next = i; } } throw new TypeError(typeof e + " is not iterable"); } return GeneratorFunction.prototype = GeneratorFunctionPrototype, o(g, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), o(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, u, "GeneratorFunction"), e.isGeneratorFunction = function (t) { var e = "function" == typeof t && t.constructor; return !!e && (e === GeneratorFunction || "GeneratorFunction" === (e.displayName || e.name)); }, e.mark = function (t) { return Object.setPrototypeOf ? Object.setPrototypeOf(t, GeneratorFunctionPrototype) : (t.__proto__ = GeneratorFunctionPrototype, define(t, u, "GeneratorFunction")), t.prototype = Object.create(g), t; }, e.awrap = function (t) { return { __await: t }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, c, function () { return this; }), e.AsyncIterator = AsyncIterator, e.async = function (t, r, n, o, i) { void 0 === i && (i = Promise); var a = new AsyncIterator(wrap(t, r, n, o), i); return e.isGeneratorFunction(r) ? a : a.next().then(function (t) { return t.done ? t.value : a.next(); }); }, defineIteratorMethods(g), define(g, u, "Generator"), define(g, a, function () { return this; }), define(g, "toString", function () { return "[object Generator]"; }), e.keys = function (t) { var e = Object(t), r = []; for (var n in e) r.push(n); return r.reverse(), function next() { for (; r.length;) { var t = r.pop(); if (t in e) return next.value = t, next.done = !1, next; } return next.done = !0, next; }; }, e.values = values, Context.prototype = { constructor: Context, reset: function reset(e) { if (this.prev = 0, this.next = 0, this.sent = this._sent = t, this.done = !1, this.delegate = null, this.method = "next", this.arg = t, this.tryEntries.forEach(resetTryEntry), !e) for (var r in this) "t" === r.charAt(0) && n.call(this, r) && !isNaN(+r.slice(1)) && (this[r] = t); }, stop: function stop() { this.done = !0; var t = this.tryEntries[0].completion; if ("throw" === t.type) throw t.arg; return this.rval; }, dispatchException: function dispatchException(e) { if (this.done) throw e; var r = this; function handle(n, o) { return a.type = "throw", a.arg = e, r.next = n, o && (r.method = "next", r.arg = t), !!o; } for (var o = this.tryEntries.length - 1; o >= 0; --o) { var i = this.tryEntries[o], a = i.completion; if ("root" === i.tryLoc) return handle("end"); if (i.tryLoc <= this.prev) { var c = n.call(i, "catchLoc"), u = n.call(i, "finallyLoc"); if (c && u) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } else if (c) { if (this.prev < i.catchLoc) return handle(i.catchLoc, !0); } else { if (!u) throw Error("try statement without catch or finally"); if (this.prev < i.finallyLoc) return handle(i.finallyLoc); } } } }, abrupt: function abrupt(t, e) { for (var r = this.tryEntries.length - 1; r >= 0; --r) { var o = this.tryEntries[r]; if (o.tryLoc <= this.prev && n.call(o, "finallyLoc") && this.prev < o.finallyLoc) { var i = o; break; } } i && ("break" === t || "continue" === t) && i.tryLoc <= e && e <= i.finallyLoc && (i = null); var a = i ? i.completion : {}; return a.type = t, a.arg = e, i ? (this.method = "next", this.next = i.finallyLoc, y) : this.complete(a); }, complete: function complete(t, e) { if ("throw" === t.type) throw t.arg; return "break" === t.type || "continue" === t.type ? this.next = t.arg : "return" === t.type ? (this.rval = this.arg = t.arg, this.method = "return", this.next = "end") : "normal" === t.type && e && (this.next = e), y; }, finish: function finish(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.finallyLoc === t) return this.complete(r.completion, r.afterLoc), resetTryEntry(r), y; } }, catch: function _catch(t) { for (var e = this.tryEntries.length - 1; e >= 0; --e) { var r = this.tryEntries[e]; if (r.tryLoc === t) { var n = r.completion; if ("throw" === n.type) { var o = n.arg; resetTryEntry(r); } return o; } } throw Error("illegal catch attempt"); }, delegateYield: function delegateYield(e, r, n) { return this.delegate = { iterator: values(e), resultName: r, nextLoc: n }, "next" === this.method && (this.arg = t), y; } }, e; }
var jobUtils = require("../utils/jobs");
var paymentUtils = require("../utils/payments");
var Parse = require("parse");

/**
 * Contains functions for calling and declaring
 *
 * @class Jobin.Analytics
 * @static
 * @hideconstructor
 */

/**
 * Count the total Jobs created between two dates
 * @method countJobs
 * @name Jobin.Analytics.countJobs
 * @param {Date} startDate
 * @param {Date} endDate
 * @param {string} jobType
 * @returns {int}
 */
export function countJobs(_x, _x2, _x3) {
  return _countJobs.apply(this, arguments);
}
function _countJobs() {
  _countJobs = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(startDate, endDate, jobType) {
    var query;
    return _regeneratorRuntime().wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          query = new Parse.Query(Parse.Object.extend("Jobs")); //No dates. Search Jobs for current date
          if (startDate && !endDate) {
            query.greaterThanOrEqualTo("createdAt", startDate);
          } else if (!startDate && endDate) {
            query.lessThanOrEqualTo("createdAt", endDate);
          } else if (startDate && endDate) {
            query.greaterThanOrEqualTo("createdAt", startDate);
            query.lessThanOrEqualTo("createdAt", endDate);
          }
          if (jobType) query.equalTo("JobType", jobType);
          _context.prev = 3;
          _context.next = 6;
          return query.count();
        case 6:
          _context.t0 = _context.sent;
          return _context.abrupt("return", {
            status: "ok",
            result: _context.t0
          });
        case 10:
          _context.prev = 10;
          _context.t1 = _context["catch"](3);
          console.error(_context.t1);
          return _context.abrupt("return", {
            status: "error",
            result: "Algo ha fallado al tratar de contar el número de trabajos"
          });
        case 14:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[3, 10]]);
  }));
  return _countJobs.apply(this, arguments);
}
var leadFields = [{
  name: "id",
  extract: function extract(job) {
    return job.id;
  }
}, {
  name: "Vertical",
  extract: function extract(job) {
    return job.get("Type");
  }
}, {
  name: "Subvertical",
  extract: function extract(job, user, subv) {
    return subv ? subv.get("Type") : "";
  }
}, {
  name: "Title",
  extract: function extract(job) {
    return job.get("Title").replace(/[\n\r\t]/, " ");
  }
}, {
  name: "JobType",
  extract: function extract(job) {
    return job.get("JobType");
  }
}, {
  name: "State",
  extract: function extract(job) {
    return job.get("State");
  }
}, {
  name: "PostalCode",
  extract: function extract(job) {
    return job.get("PostalCode");
  }
}, {
  name: "TotalSlots",
  extract: function extract(job) {
    return job.get("TotalSlots");
  }
}, {
  name: "TakenSlots",
  extract: function extract(job) {
    return job.get("TotalSlots") - job.get("nJober");
  }
}, {
  name: "Name",
  extract: function extract(job, user) {
    return user && user.has("Name") ? user.get("Name").replace(/[\n\r\t]/, " ") : "";
  }
}, {
  name: "Phone",
  extract: function extract(job, user) {
    return user ? user.get("Phone") : "";
  }
}, {
  name: "CreatedAt",
  extract: function extract(job) {
    return job.get("createdAt").toLocaleString("es-ES");
  }
}, {
  name: "LeadPrice",
  extract: function extract(job, user, subv) {
    return subv ? subv.get("nLeads") : "";
  }
}, {
  name: "Level",
  extract: function extract(job) {
    return job.has("Level") ? job.get("Level") : 1;
  }
}, {
  name: "Business",
  extract: function extract(job, user, subv, business) {
    return business ? business.get("Name") : "";
  }
}];
var transportFields = [{
  name: "id",
  extract: function extract(job, user, subv, business, item) {
    return item.get("ID");
  }
}, {
  name: "PostalCode",
  extract: function extract(job) {
    return job.get("PostalCode");
  }
}, {
  name: "Title",
  extract: function extract(job) {
    return job.get("Title").replace(/[\n\r\t]/, " ");
  }
}, {
  name: "State",
  extract: function extract(job, user, subv, business, item) {
    return item.get("State");
  }
}, {
  name: "Name",
  extract: function extract(job, user) {
    return user && user.has("Name") ? user.get("Name").replace(/[\n\r\t]/, " ") : "";
  }
}, {
  name: "Phone",
  extract: function extract(job, user) {
    return user ? user.get("Phone") : "";
  }
}, {
  name: "CreatedAt",
  extract: function extract(job, user, subv, business, item) {
    return item.get("createdAt").toLocaleString("es-ES");
  }
}, {
  name: "DeliveryDate",
  extract: function extract(job, user, subv, business, item) {
    return item.has("DeliveryDate") ? item.get("DeliveryDate").toLocaleString("es-ES") : "";
  }
}, {
  name: "PVP",
  extract: function extract(job, user, subv, business, item) {
    return item.has("Price") ? (item.get("Price") * 1.21).toFixed(2).replace(".", ",") : "0,00";
  }
}, {
  name: "Level",
  extract: function extract(job) {
    return job.has("Level") ? job.get("Level") : 1;
  }
}, {
  name: "Business",
  extract: function extract(job, user, subv, business) {
    return business ? business.get("Name") : "";
  }
}, {
  name: "Distance",
  extract: function extract(job, user, subv, business, item) {
    return item.has("Distance") ? item.get("Distance").toFixed(3).replace(".", ",") : "0,000";
  }
}, {
  name: "Weight",
  extract: function extract(job, user, subv, business, item) {
    return item.has("Weight") ? item.get("Weight").toFixed(0) : "0";
  }
}];
var fixedFields = [{
  name: "id",
  extract: function extract(job, user, subv, business, item) {
    return item.get("ID");
  }
}, {
  name: "Vertical",
  extract: function extract(job) {
    return job.get("Type");
  }
}, {
  name: "Subvertical",
  extract: function extract(job, user, subv) {
    return subv ? subv.get("Type") : "";
  }
}, {
  name: "Title",
  extract: function extract(job) {
    return job.get("Title").replace(/[\n\r\t]/, " ");
  }
}, {
  name: "PostalCode",
  extract: function extract(job) {
    return job.get("PostalCode");
  }
}, {
  name: "State",
  extract: function extract(job) {
    return job.get("State");
  }
}, {
  name: "Name",
  extract: function extract(job, user) {
    return user && user.has("Name") ? user.get("Name").replace(/[\n\r\t]/, " ") : "";
  }
}, {
  name: "Phone",
  extract: function extract(job, user) {
    return user ? user.get("Phone") : "";
  }
}, {
  name: "CreatedAt",
  extract: function extract(job, user, subv, business, item) {
    return item.get("createdAt").toLocaleString("es-ES");
  }
}, {
  name: "BasePVP",
  extract: function extract(job, user, subv, business, item) {
    return item.has("BasicPrice") ? (item.get("BasicPrice") * 1.21).toFixed(2).replace(".", ",") : "0,00";
  }
}, {
  name: "ExtrasPVP",
  extract: function extract(job, user, subv, business, item) {
    return (((item.get("FixedPrice") || 0) - (item.get("BasicPrice") || 0)) * 1.21).toFixed(2).replace(".", ",");
  }
}, {
  name: "TotalPVP",
  extract: function extract(job, user, subv, business, item) {
    return item.has("FixedPrice") ? (item.get("FixedPrice") * 1.21).toFixed(2).replace(".", ",") : "0,00";
  }
}, {
  name: "Extras",
  extract: function extract(job, user, subv, business, item) {
    return item.has("Extras") ? JSON.stringify(item.get("Extras")) : "";
  }
}, {
  name: "Business",
  extract: function extract(job, user, subv, business) {
    return business ? business.get("Name") : "";
  }
}];
var paymentFields = [{
  name: "id",
  extract: function extract(payment) {
    return payment.id;
  }
}, {
  name: "CreatedAt",
  extract: function extract(payment) {
    return payment.get("createdAt").toLocaleString("es-ES");
  }
}, {
  name: "Type",
  extract: function extract(payment) {
    return payment.get("Type");
  }
}, {
  name: "Num_Factura",
  extract: function extract(payment) {
    return payment.get("ReceiptName");
  }
}, {
  name: "Method",
  extract: function extract(payment) {
    return payment.get("Method");
  }
}, {
  name: "BasePrice",
  extract: function extract(payment) {
    return payment.has("Price") ? payment.get("Price").toFixed(3).replace(".", ",") : "0,000";
  }
}, {
  name: "IVA",
  extract: function extract(payment) {
    return payment.has("Price") ? (payment.get("Price") * 0.21).toFixed(3).replace(".", ",") : "0,000";
  }
}, {
  name: "TotalPrice",
  extract: function extract(payment) {
    return payment.has("Price") ? (payment.get("Price") * 1.21).toFixed(2).replace(".", ",") : "0,00";
  }
}, {
  name: "BusinessName",
  extract: function extract(payment, business) {
    return business ? business.get("Name") : 'Jobin';
  }
}];
export function exportJobsCsv(_x4, _x5, _x6, _x7, _x8, _x9, _x10) {
  return _exportJobsCsv.apply(this, arguments);
}
function _exportJobsCsv() {
  _exportJobsCsv = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2(startDate, endDate, provinces, services, levels, slots, jobStates) {
    var id,
      stores,
      orders,
      creationDate,
      deliveryDate,
      businesses,
      agents,
      finalQuery,
      _yield$finalQuery$wit,
      results,
      count,
      offset,
      fields,
      headers,
      formattedJobs,
      _args2 = arguments;
    return _regeneratorRuntime().wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          id = _args2.length > 7 && _args2[7] !== undefined ? _args2[7] : "";
          stores = _args2.length > 8 ? _args2[8] : undefined;
          orders = _args2.length > 9 ? _args2[9] : undefined;
          creationDate = _args2.length > 10 ? _args2[10] : undefined;
          deliveryDate = _args2.length > 11 ? _args2[11] : undefined;
          businesses = _args2.length > 12 ? _args2[12] : undefined;
          agents = _args2.length > 13 ? _args2[13] : undefined;
          _context2.next = 9;
          return jobUtils.getFullQuery(undefined,
          // user
          1000, startDate, endDate, provinces, services, levels, slots, jobStates, id, stores, orders, creationDate, deliveryDate, businesses, agents);
        case 9:
          finalQuery = _context2.sent;
          console.info(finalQuery);
          if (id.startsWith("PC-")) {
            finalQuery.include(["Job", "Job.CreatedBy", "Job.Subvertical", "Job.Business"]);
          } else if (id.startsWith("TR-")) {
            finalQuery.include(["Job", "Job.CreatedBy", "Job.Subvertical", "Job.Business"]);
          } else {
            finalQuery.include(["CreatedBy", "Subvertical", "Business"]);
          }
          _context2.next = 14;
          return finalQuery.withCount(true).find();
        case 14:
          _yield$finalQuery$wit = _context2.sent;
          results = _yield$finalQuery$wit.results;
          count = _yield$finalQuery$wit.count;
          if (!(results.length < count)) {
            _context2.next = 29;
            break;
          }
          offset = results.length;
          finalQuery.withCount(false);
        case 20:
          if (!(offset < count)) {
            _context2.next = 29;
            break;
          }
          _context2.t0 = results;
          _context2.next = 24;
          return finalQuery.skip(offset).find();
        case 24:
          _context2.t1 = _context2.sent;
          results = _context2.t0.concat.call(_context2.t0, _context2.t1);
          offset = results.length;
          _context2.next = 20;
          break;
        case 29:
          fields = id.startsWith("PC-") ? fixedFields : id.startsWith("TR-") ? transportFields : leadFields;
          headers = fields.map(function (field) {
            return field.name;
          }).join("\t") + "\n";
          formattedJobs = results.map(function (item) {
            var job = item.has("Job") ? item.get("Job") : item;
            var user = job.get("CreatedBy");
            var business = job.get("Business");
            var subvertical = job.has("Subvertical") ? job.get("Subvertical") : job.get("Vertical");
            return fields.map(function (field) {
              return field.extract(job, user, subvertical, business, item);
            }).join("\t") + "\n";
          });
          return _context2.abrupt("return", headers.concat.apply(headers, _toConsumableArray(formattedJobs)));
        case 33:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return _exportJobsCsv.apply(this, arguments);
}
export function exportPaymentsCsv(_x11) {
  return _exportPaymentsCsv.apply(this, arguments);
}
function _exportPaymentsCsv() {
  _exportPaymentsCsv = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3(_ref) {
    var startDate, endDate, methodArray, typeArray, stateArray, postalPrefixes, signArray, businessIdArray, user, id, query, _yield$query$withCoun, results, count, offset, headers, formattedJobs;
    return _regeneratorRuntime().wrap(function _callee3$(_context3) {
      while (1) switch (_context3.prev = _context3.next) {
        case 0:
          startDate = _ref.startDate, endDate = _ref.endDate, methodArray = _ref.methodArray, typeArray = _ref.typeArray, stateArray = _ref.stateArray, postalPrefixes = _ref.postalPrefixes, signArray = _ref.signArray, businessIdArray = _ref.businessIdArray, user = _ref.user, id = _ref.id;
          query = paymentUtils.getPaymentsQuery({
            startDate: startDate,
            endDate: endDate,
            methodArray: methodArray,
            typeArray: typeArray,
            stateArray: stateArray,
            postalPrefixes: postalPrefixes,
            signArray: signArray,
            //[ "positive" | "negative" ]
            businessIdArray: businessIdArray,
            user: user,
            id: id
          });
          query.include("Business").ascending("createdAt");
          _context3.next = 5;
          return query.withCount(true).find();
        case 5:
          _yield$query$withCoun = _context3.sent;
          results = _yield$query$withCoun.results;
          count = _yield$query$withCoun.count;
          if (!(results.length < count)) {
            _context3.next = 20;
            break;
          }
          offset = results.length;
          query.withCount(false);
        case 11:
          if (!(offset < count)) {
            _context3.next = 20;
            break;
          }
          _context3.t0 = results;
          _context3.next = 15;
          return query.skip(offset).find();
        case 15:
          _context3.t1 = _context3.sent;
          results = _context3.t0.concat.call(_context3.t0, _context3.t1);
          offset = results.length;
          _context3.next = 11;
          break;
        case 20:
          headers = paymentFields.map(function (field) {
            return field.name;
          }).join("\t") + "\n";
          formattedJobs = results.map(function (payment) {
            return paymentFields.map(function (field) {
              return field.extract(payment, payment.get("Business"));
            }).join("\t") + "\n";
          });
          return _context3.abrupt("return", headers.concat.apply(headers, _toConsumableArray(formattedJobs)));
        case 23:
        case "end":
          return _context3.stop();
      }
    }, _callee3);
  }));
  return _exportPaymentsCsv.apply(this, arguments);
}